export const LOAD = 'REDUX_STORAGE_LOAD';
export const SAVE = 'REDUX_STORAGE_SAVE';
